import React, { memo } from 'react';

import { Block } from '../../components/core';
import { PeerGroupAnalysisHeader } from './peer-group-analysis-header';
import { PeerGroupAnalysisContent } from './peer-group-analysis-content';

import { MetricsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/MetricsErrorWrapper';
import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';

interface PeerGroupAnalysisBlockProps {
  id: string;
}

export const PeerGroupAnalysisBlock = memo(function InternalPeerGroupAnalysisBlock({
  id,
}: PeerGroupAnalysisBlockProps) {
  return (
    <Block.Root id={id}>
      <Block.Header>
        <PeerGroupAnalysisHeader id={id} />
      </Block.Header>

      <Block.Content id={id} errorWrappers={[...COMMON_ERROR_WRAPPERS, MetricsErrorWrapper]}>
        <PeerGroupAnalysisContent id={id} />
      </Block.Content>
    </Block.Root>
  );
});
